import { useNavigate } from 'react-router';

import { useBanActions, useBanState } from '@/pages/auth/reset-password/store/ban.store';
import { AuthPaths } from '@/shared/lib/react-router';

import { getExpiredTimestamp } from '../../helpers/helpers';

export const useBan = () => {
  const { resetBan, setExpiredAt } = useBanActions();
  const { expiredAt } = useBanState();
  const navigate = useNavigate();

  return {
    resetBan,
    applyBan(value: number) {
      setExpiredAt(getExpiredTimestamp(value));
      navigate(AuthPaths.RESET_PASSWORD.BAN);
    },
    expiredAt,
  };
};
